import imageOne from '@/assets/images/cities/vaughan1.jpg'
import imageTwo from '@/assets/images/cities/vaughan2.jpg'
import imageThree from '@/assets/images/cities/vaughan3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Woodbridge',
  writeup: '',
  website: '',
  url: '',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(647) 795-2772',
      hours: {
        monday: '12:00PM to 5:00PM',
        tuesday: '12:00PM to 5:00PM',
        wednesday: '12:00PM to 5:00PM',
        thursday: '12:00PM to 5:00PM',
        friday: '12:00PM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: 'Islington Ave Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/woodbridge.js